// if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
//     const targets = document.querySelectorAll("[bss-b2b-main-product-form]");

//     const config = {
//         childList: true,   
//         attributes: true,
//         characterData: true,
//         subtree: true
//     };

//     const callback = function(mutationsList, observer) {
//         for (const mutation of mutationsList) {
//             if (mutation.type === "childList") {
//                 setTimeout(() => {
//                     const productForms = document.querySelectorAll("[bss-b2b-product-form-id]");
//                     productForms.forEach(productForm => {
//                         BSS_B2B?.observer?.productSubject?.notifyObserver?.('VariantChange', 'VariantSelectChange', {productForm});
//                     });
//                 },1000)
//             }
//         }
//     };

//     const observer = new MutationObserver(callback);

//     targets.forEach(target => {
//         observer.observe(target, config);
//     });
// }

document.addEventListener("click", function (e) {
    const label = e.target.closest(".product-form__label.available");
    if (!label) return;

    const productForm = label.closest("[bss-b2b-main-product-form]");
    if (!productForm) return;

    setTimeout(() => {
        BSS_B2B?.observer?.productSubject?.notifyObserver?.(
        "VariantChange",
        "VariantSelectChange",
        { productForm }
    );
    }, 1000);
});


document.addEventListener('DOMContentLoaded', function () {
  const teButton = document.querySelector('.bss-b2b-tax-ex-wrapper.bss-config-header');
  const cartActions = document.querySelector('.cart-actions');

  if (teButton && cartActions) {
    cartActions.insertBefore(teButton, cartActions.firstChild);
  }
});
